import { __extends, __rest, __assign } from 'tslib';
import * as React from 'react';
import { UitkFullscreenDialog, UitkDialogAnimationType, UitkFullscreenDialogTheme } from 'uitk-react-dialog';
import { classNames } from 'uitk-react-utils';
import { UitkTransparentToolbar } from 'uitk-react-toolbar';
import styles from './uitk-media-gallery.css';

var getClassNameList = classNames.bind(styles);
var UitkMediaGalleryImageDialog = /** @class */ (function (_super) {
    __extends(UitkMediaGalleryImageDialog, _super);
    function UitkMediaGalleryImageDialog(props) {
        var _this = _super.call(this, props) || this;
        _this.onDismiss = _this.onDismiss.bind(_this);
        return _this;
    }
    UitkMediaGalleryImageDialog.prototype.onDismiss = function () {
        var onDismiss = this.props.onDismiss;
        if (onDismiss) {
            onDismiss();
        }
    };
    UitkMediaGalleryImageDialog.prototype.render = function () {
        var _a = this.props, analytics = _a.analytics, ariaLabel = _a.ariaLabel, buttonRef = _a.buttonRef, children = _a.children, closeCallback = _a.closeCallback, openCallback = _a.openCallback, returnFocusOnClose = _a.returnFocusOnClose, toolbarAttributes = __rest(_a, ["analytics", "ariaLabel", "buttonRef", "children", "closeCallback", "openCallback", "returnFocusOnClose"]);
        return (React.createElement(UitkFullscreenDialog, { ariaLabel: ariaLabel, className: getClassNameList('uitk-media-gallery-image-dialog'), animation: UitkDialogAnimationType.SLIDEUP, closeCallback: closeCallback, dialogShow: true, openCallback: openCallback, returnFocusOnClose: returnFocusOnClose, strictFullscreen: true, theme: UitkFullscreenDialogTheme.DARK },
            React.createElement(UitkTransparentToolbar, { overlay: true, navigationContent: __assign({ navButtonId: 'UitkMediaGalleryImageToolbar', navButtonRef: buttonRef, onClick: this.onDismiss, onClickAnalytics: analytics }, toolbarAttributes) }),
            children));
    };
    UitkMediaGalleryImageDialog.displayName = 'UitkMediaGalleryImageDialog';
    return UitkMediaGalleryImageDialog;
}(React.Component));

export { UitkMediaGalleryImageDialog };
